<template>
  <tr
    :class="{
      'bg-tbl-pink': selectedCd === deliveryData.delivery_cd,
      'bg-tbl-green': deliveryData.new_fg == 1,
      'bg-tbl-light': deliveryData.modify_fg == 9
    }"
  >
    <td class="text-center">
      <button
        class="btn btn-sm btn-primary"
        data-toggle="modal"
        data-target="#modal01"
        :disabled="deliveryData.modify_fg == 9"
        @click.prevent="startEditHandler"
      >
        修正</button
      ><button
        class="btn btn-sm btn-info"
        :disabled="deliveryData.modify_fg == 9"
        @click.prevent="startDeleteHandler"
      >
        削除
      </button>
    </td>
    <td>
      <template v-if="deliveryData.modify_fg">
        <span
          v-if="deliveryData.modify_fg == 1"
          class="badge badge-primary mb-1"
          >修正中</span
        >
        <span
          v-if="deliveryData.modify_fg == 9"
          class="badge badge-secondary mb-1"
          >削除中</span
        >
        <br /> </template
      >{{ deliveryData.dlcompany_na }}
    </td>
    <td>{{ deliveryData.dlcompanysub_na }}</td>
    <td>{{ deliveryData.dladdress_na }}</td>
    <td>{{ deliveryData.dltel_no }}</td>
    <td>
      <button
        class="btn btn-sm btn-request"
        @click.prevent="selectDeliveryDataHandler"
        :deliveryData="deliveryData.modify_fg == 9"
      >
        選 択
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    selectedCd: { type: String, required: true },
    deliveryData: { type: Object, required: true }
  },
  methods: {
    startEditHandler() {
      this.$emit("edit", this.deliveryData);
    },
    startDeleteHandler() {
      this.$emit("delete", this.deliveryData);
    },
    selectDeliveryDataHandler() {
      this.$emit("select", this.deliveryData);
    }
  }
};
</script>
